(function () {
    // Robust selectors that don't throw on null roots
    function qs(sel, root = document) {
        if (!root) return null;
        return root.querySelector(sel);
    }
    function qsa(sel, root = document) {
        if (!root) return [];
        return Array.from(root.querySelectorAll(sel));
    }

    function khBindGallery(section) {
        const main = qs('[data-kh-main-image], .kh-main-image', section);
        const thumbs = qsa('[data-kh-thumb], .kh-thumb', section);

        if (!main || !thumbs.length) return;

        // Reset and set active
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumbs[0]?.classList.add('is-active');

        thumbs.forEach((thumb) => {
            const handleSwitch = () => {
                const newSrc = thumb.dataset.khImage || thumb.getAttribute('data-kh-image');
                if (!newSrc || main.src === newSrc) return;

                thumbs.forEach(t => t.classList.remove('is-active'));
                thumb.classList.add('is-active');

                main.classList.add('is-changing');

                const img = new Image();
                img.onload = () => {
                    main.src = newSrc;
                    if (thumb.getAttribute('data-srcset')) {
                        main.srcset = thumb.getAttribute('data-srcset');
                    }
                    requestAnimationFrame(() => main.classList.remove('is-changing'));
                };
                img.src = newSrc;
            };

            thumb.addEventListener('click', handleSwitch);
            thumb.addEventListener('mouseenter', handleSwitch);
        });
    }

    // Initialize all cinematic components
    function initCinematicUI(target) {
        // Handle both event-based and direct calls
        const section = target instanceof HTMLElement ? target : qs('[data-kh-product-section]');
        if (!section || section.dataset.khInitialized) return;
        section.dataset.khInitialized = 'true';

        khBindGallery(section);
        initUpload(section);
        initGSAP(section);
        initModal(section);
        initPurchase(section);
    }

    function initUpload(section) {
        const fileInput = qs('input[type="file"][data-kh-upload]', section);
        const frameImg = qs('[data-kh-upload-preview]', section);
        const fileName = qs('[data-kh-upload-filename]', section);
        if (!fileInput || !frameImg || !fileName) return;

        fileInput.addEventListener('change', () => {
            const file = fileInput.files && fileInput.files[0];
            if (!file) return;
            fileName.textContent = file.name;

            const url = URL.createObjectURL(file);
            frameImg.src = url;
            frameImg.style.display = 'block';
        });
    }

    function initGSAP(section) {
        if (!window.gsap || !window.ScrollTrigger) return;
        gsap.registerPlugin(ScrollTrigger);

        const reveals = qsa('.kh-reveal', section);
        reveals.forEach((el) => {
            gsap.to(el, {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power3.out",
                scrollTrigger: { trigger: el, start: "top 90%" }
            });
        });

        const infoElements = qsa('.kh-info > *:not(.kh-reveal), .kh-spec-row, .kh-purchase > *', section);
        if (infoElements.length) {
            gsap.to(infoElements, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.08,
                ease: "power3.out",
                scrollTrigger: { trigger: '.kh-info', start: "top 85%" }
            });
        }
    }

    function initModal(section) {
        const triggers = qsa('[data-kh-open-modal]', section);
        const overlay = qs('#khCustomModal');
        if (!triggers.length || !overlay) return;

        const panel = qs('.kh-modal', overlay);
        const closeElements = qsa('[data-kh-close-modal], .kh-modal-close', overlay);
        const form = qs('#kh-custom-request-form', overlay);
        const submitBtn = qs('.kh-modal-submit', form);

        triggers.forEach(trigger => {
            const openModal = () => {
                overlay.removeAttribute('hidden');
                document.body.style.overflow = 'hidden';

                // Trigger animation
                requestAnimationFrame(() => {
                    panel?.classList.add('is-open');
                    panel?.classList.add('is-visible'); // Helpful for CSS management
                });

                const firstInput = qs('input, textarea, select', panel);
                if (firstInput) firstInput.focus();
            };

            const closeModal = () => {
                panel?.classList.remove('is-open');

                // Wait for animation to finish before hiding overlay
                setTimeout(() => {
                    overlay.setAttribute('hidden', '');
                    document.body.style.overflow = '';
                    trigger.focus();
                }, 300);
            };

            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                openModal();
            });

            closeElements.forEach(el => el.addEventListener('click', closeModal));

            window.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closeModal();
            });
        });

        // Form Loading State
        if (form && submitBtn) {
            initColorReplacement(form);
            form.addEventListener('submit', () => {
                submitBtn.classList.add('is-loading');
                const span = qs('span', submitBtn);
                if (span) span.textContent = 'Sending Request...';
            });
        }
    }

    function initColorReplacement(form) {
        const rows = qsa('.kh-color-row', form);
        const summaryInput = qs('#khColorReplacementsSummary', form);
        if (!rows.length || !summaryInput) return;

        rows.forEach(row => {
            const radios = qsa('.kh-color-radio', row);
            const paletteContainer = qs('.kh-replacement-container', row);
            const tiles = qsa('.kh-palette-tile', row);
            const hiddenValue = qs('.kh-replacement-value', row);

            radios.forEach(radio => {
                radio.addEventListener('change', () => {
                    if (radio.value === 'replace' && radio.checked) {
                        paletteContainer.removeAttribute('hidden');
                        hiddenValue.disabled = false;
                    } else {
                        paletteContainer.setAttribute('hidden', '');
                        hiddenValue.disabled = true;
                    }
                });
            });

            tiles.forEach(tile => {
                tile.addEventListener('click', () => {
                    tiles.forEach(t => t.classList.remove('is-selected'));
                    tile.classList.add('is-selected');
                    hiddenValue.value = tile.dataset.colorName;
                });
            });
        });

        form.addEventListener('submit', () => {
            let summary = [];
            rows.forEach(row => {
                const originalName = row.dataset.originalColor;
                const replaceRadio = qs('input[value="replace"]', row);
                const hiddenValue = qs('.kh-replacement-value', row);

                if (replaceRadio && replaceRadio.checked && hiddenValue.value) {
                    summary.push(`${originalName}: Replace -> ${hiddenValue.value}`);
                } else {
                    summary.push(`${originalName}: Keep`);
                }
            });
            summaryInput.value = summary.join('\n');
        });
    }

    function initPurchase(section) {
        const variants = qsa('.kh-chip__input', section);
        const hiddenIdInput = qs('[data-kh-variant-id]', section);
        const priceDisplay = qs('[data-kh-price]', section);
        const compareDisplay = qs('[data-kh-compare-price]', section);

        variants.forEach(radio => {
            radio.addEventListener('change', () => {
                const id = radio.value;
                const price = radio.getAttribute('data-price');
                const compare = radio.getAttribute('data-compare-price');
                if (hiddenIdInput) hiddenIdInput.value = id;
                if (priceDisplay && price) priceDisplay.innerHTML = price;
                if (compareDisplay && compare) compareDisplay.innerHTML = compare;
            });
        });

        // Qty logic
        const qtyInputs = qsa('[data-qty-input]', section);
        qtyInputs.forEach(input => {
            const row = input.closest('.kh-qty-pill');
            const inc = qs('[data-qty-inc]', row);
            const dec = qs('[data-qty-dec]', row);
            if (inc) inc.addEventListener('click', () => { input.value = parseInt(input.value) + 1; });
            if (dec) dec.addEventListener('click', () => { if (input.value > 1) input.value = parseInt(input.value) - 1; });
        });
    }

    // Lifecycle Bindings
    document.addEventListener('DOMContentLoaded', initCinematicUI);
    document.addEventListener('shopify:section:load', (e) => initCinematicUI(e.target));
    document.addEventListener('shopify:section:select', (e) => initCinematicUI(e.target));
})();
